/**
 * Type guard for None
 * @param nullable any value that is Nullable
 * @returns boolean
 *
 * isNone(null) -> true
 * isNone(undefined) -> true
 * isNone('') -> false
 * isNone(0) -> false
 * isNone(false) -> false
 * isNone({}) -> false
 * isNone([]) -> false */
export function isNone(nullable) {
  return nullable === null || nullable === undefined;
}

/**
 * Type guard for T
 * @param nullable any value that is Nullable
 * @returns boolean
 *
 * isSome(null) -> false
 * isSome(undefined) -> false
 * isSome('') -> true
 * isSome(0) -> true
 * isSome(false) -> true
 * isSome({}) -> true
 * isSome([]) -> true */
export function isSome(nullable) {
  return !isNone(nullable);
}
export function isError(error) {
  return error instanceof Error;
}
export function isString(x) {
  return typeof x === 'string';
}
export function isObject(x) {
  return isSome(x) && typeof x === 'object';
}
export const isNumeric = value => isSome(value) && !isNaN(value) && typeof value === 'number';
export function parseNumber(value) {
  if (isNone(value) || value.trim() === '') {
    return null;
  }
  const parsed = Number(value);
  if (isNumeric(parsed)) {
    return parsed;
  }
  return null;
}
export function parseNumberOrThrow(value) {
  const parsed = parseNumber(value);
  if (isNone(parsed)) {
    throw new Error(`Could not parse number from ${value}`);
  }
  return parsed;
}

/** @deprecated use getProperty in gqlHelpers */
export function getValue(property) {
  var _property$value;
  if ((property === null || property === void 0 ? void 0 : property.value) === '') {
    return null;
  }
  return (_property$value = property === null || property === void 0 ? void 0 : property.value) !== null && _property$value !== void 0 ? _property$value : null;
}
export const cloneOf = obj => 'structuredClone' in window && structuredClone ? structuredClone(obj) : JSON.parse(JSON.stringify(obj));

/** forces exhaustive checking in a switch statement (you will get a type error if you don't check every case) and throws a traceable error if it ever actually gets called at runtime.
 * Stick it in the default case of a switch statement to make sure you've covered all cases.  */
export function assertNever(val, message) {
  throw new Error(message || 'unexpected never case encountered');
}